import DrillSizeField from './drillSizeField';
import TablelegItem from '../item/tablelegItem';

/**
 * @class TablelegSizeField
 */
export default class TablelegSizeField extends DrillSizeField {
    type = 'tablelegSize';
    supports = null;

    /**
     * Check if field is supportet by item.
     *
     * @param {ItemInterface} item
     * @param {number} selectionLength
     *
     * @return {boolean}
     */
    isSupported(item, selectionLength) {
        return selectionLength === 1
            && item
            && item instanceof TablelegItem;
    }
}
